import { Link } from 'react-router-dom';
import { ResourceItem } from '@/components/ui/ResourceItem';
import classroomManagementPhoto from '@/assets/classroom-management.jpg';
import difficultConversationsPhoto from '@/assets/difficult-conversations.jpg';

const pdfResources = [
  {
    type: 'pdf' as const,
    title: 'Classroom Management Framework',
    description: 'Comprehensive guide to effective classroom management strategies and techniques',
    pages: 20,
    addedDate: '2 days ago',
    photo: classroomManagementPhoto
  },
  {
    type: 'pdf' as const,
    title: 'Difficult Conversations Guide',
    description: 'Navigate challenging discussions with parents, colleagues, and administrators',
    pages: 10,
    addedDate: '3 weeks ago',
    photo: difficultConversationsPhoto
  },
  {
    type: 'pdf' as const,
    title: 'Parent Communication Templates',
    description: 'Ready-to-use templates for effective parent communication',
    pages: 15,
    addedDate: '1 Month Ago'
  }
];

export const ResourcesPDFPage = () => (
  <div className="space-y-8 animate-fade-in">
    <div className="flex justify-between items-start">
      <h1 className="text-3xl font-semibold text-white font-literata mb-2">PDF Resources</h1>
      <div className="flex space-x-6">
        <Link to="/resources" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">All</Link>
        <Link to="/resources/pdf" className="text-white border-b-2 border-bodhi-orange pb-1">PDF</Link>
        <Link to="/resources/audio" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">Audio</Link>
        <Link to="/resources/favorites" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">Favorites</Link>
      </div>
    </div>
    <div className="overflow-x-auto pb-4">
      <div className="flex space-x-4 animate-fade-in">
        {pdfResources.map((resource, index) => (
          <ResourceItem
            key={index}
            type={resource.type}
            title={resource.title}
            description={resource.description}
            pages={resource.pages}
            addedDate={resource.addedDate}
            photo={resource.photo}
          />
        ))}
      </div>
    </div>
  </div>
);